export enum ValueCompareEnum {
    ORIGINAL_VALUE_ONLY = 'original_value_only',
    PREDICTED_VALUE_ONLY = 'predicted_value_only',
    DIFFERENT_VALUES = 'different_values',
    NO_VALUES = 'no_values'
}

export const getCompareEnum = (originalValue?: string | number | null, predictedValue?: string | number | null) => {
    const originalValueExist = originalValue !== null && originalValue !== undefined && originalValue !== '';
    const predictedValueExist = predictedValue !== null && predictedValue !== undefined && predictedValue !== '';

    if (originalValueExist && predictedValueExist) {
        return originalValue.toString() === predictedValue.toString()
            ? ValueCompareEnum.ORIGINAL_VALUE_ONLY
            : ValueCompareEnum.DIFFERENT_VALUES;
    }

    if (originalValueExist && !predictedValueExist) {
        return ValueCompareEnum.ORIGINAL_VALUE_ONLY;
    }

    if (!originalValueExist && predictedValueExist) {
        return ValueCompareEnum.PREDICTED_VALUE_ONLY;
    }

    return ValueCompareEnum.NO_VALUES;
};
